import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, exhaustMap, of } from 'rxjs';
import { SynchronisationProvider } from './synchronisation';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { catchError, tap } from 'rxjs/operators';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class GetInitService {
  private launchGetInit$ = new BehaviorSubject<boolean>(false);
  isRunning = toSignal(this.launchGetInit$);

  constructor(private synchronisationProvider: SynchronisationProvider) {
    this.launchGetInit$
      .pipe(
        takeUntilDestroyed(),
        exhaustMap((value) => {
          if (value) {
            return fromPromise(this.synchronisationProvider.startSynchronisation()).pipe(catchError(() => EMPTY));
          } else {
            return of();
          }
        }),
        catchError(() => EMPTY),
        tap(() => {
          this.launchGetInit$.next(false);
        })
      )
      .subscribe();
  }

  launchGetInit() {
    this.launchGetInit$.next(true);
  }
}
